import { defineMessages } from 'react-intl';

export default defineMessages({
    returnToPolicyDetails: {
        id: 'ml.agent.endorsement.views.contact-us.Return to Policy Details page',
        defaultMessage: 'Return to Policy Details page'
    },
    returnToPolicyChange: {
        id: 'ml.agent.endorsement.views.contact-us.Return to Policy Change',
        defaultMessage: 'Return to Policy Change'
    },
    reasons: {
        id: 'ml.agent.endorsement.views.contact-us.Reasons:',
        defaultMessage: 'Reasons:'
    },
    unableToCompleteQuote: {
        id: 'ml.agent.endorsement.views.contact-us.We\'re unable to complete your change',
        defaultMessage: 'We\'re unable to complete your change'
    },
    unableToCompleteQuoteOnline: {
        id: 'ml.agent.endorsement.views.contact-us.We\'re unable to complete your change online',
        defaultMessage: 'We\'re unable to complete your change online'
    },
    IAPCSValidation: {
        id: 'ml.agent.endorsement.views.contact-us.IA_PCS_VALIDATION',
        defaultMessage: 'Due to the reason(s) listed below, we are unable to proceed with your change. Click the Return to Policy Change link to resolve the item(s) listed.'
    },
    EAPCSValidationContactUs: {
        id: 'ml.agent.endorsement.views.contact-us.EA_PCS_VALIDATION_CONTACT_US',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-866-539-1315</strong>.  '
    },
    IAPCSValidationContactUs: {
        id: 'ml.agent.endorsement.views.contact-us.IA_PCS_VALIDATION_CONTACT_US',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-800-255-0332</strong>.  '
    },
    IAPCSValidationContactUs2: {
        id: 'ml.agent.endorsement.views.contact-us.IA_PCS_VALIDATION_CONTACT_US2',
        defaultMessage: 'Please include your policy number <strong>{policyNumber}</strong> and error code <strong>{errorCode}</strong>.'
    },
    IAPCSRetryable: {
        id: 'ml.agent.endorsement.views.contact-us.IA_PCS_RETRYABLE',
        defaultMessage: 'We\'re sorry, due to technical difficulties we are unable to process your change online at this time.  Please watch the dashboard for more information and try again later.'
    },
    EAPCSRetryableContactUs: {
        id: 'ml.agent.endorsement.views.contact-us.EA_PCS_RETRYABLE_CONTACT_US',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-866-539-1315</strong>. '
    },
    IAPCSRetryableContactUs: {
        id: 'ml.agent.endorsement.views.contact-us.IA_PCS_RETRYABLE_CONTACT_US',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-800-255-0332</strong>. '
    },
    IAPCSRetryableContactUs2: {
        id: 'ml.agent.endorsement.views.contact-us.IA_PCS_RETRYABLE_CONTACT_US2',
        defaultMessage: 'When contacting us, please include your policy number <strong>{policyNumber}</strong> and error code <strong>{errorCode}</strong>.'
    },
    EAPCSNonRetryable: {
        id: 'ml.agent.endorsement.views.contact-us.EA_PCS_NON_RETRYABLE',
        defaultMessage: 'We\'re sorry, we are experiencing technical difficulties with your change. Please contact us by chat or call customer service at <strong>1-866-539-1315</strong> so we may assist you with completing your change.'
    },
    IAPCSNonRetryable: {
        id: 'ml.agent.endorsement.views.contact-us.IA_PCS_NON_RETRYABLE',
        defaultMessage: 'We\'re sorry, we are experiencing technical difficulties with your change. Please contact us by chat or call customer service at <strong>1-800-255-0332</strong> so we may assist you with completing your change.'
    },
    IAPCSNonRetryableContactUs: {
        id: 'ml.agent.endorsement.views.contact-us.IA_PCS_NON_RETRYABLE_CONTACT_US',
        defaultMessage: 'When contacting us, include your policy number <strong>{policyNumber}</strong> and error code <strong>{errorCode}</strong>.'
    },
    IAPCSNonRetryableContactUsWithoutErrorCode: {
        id: 'ml.agent.endorsement.views.contact-us.IA_PCS_NON_RETRYABLE_CONTACT_US_WITHOUT_ERROR_CODE',
        defaultMessage: 'When contacting us, include your policy number <strong>{policyNumber}</strong>.'
    },
    GCSValidation: {
        id: 'ml.agent.endorsement.views.contact-us.GCS_VALIDATION',
        defaultMessage: 'Due to the reason(s) listed below, we are unable to proceed with your change. Click the Return to Policy Change link to resolve the item(s) listed.'
    },
    CSCRetryableContactUs: {
        id: 'ml.agent.endorsement.views.contact-us.CSC_RETRYABLE_CONTACT_US',
        defaultMessage: 'We\'re sorry, due to technical difficulties we are unable to process your change online at this time {errorCode}.  Please watch the dashboard for more information and try again later.'
    },
    CSCNonRetryableContactUsWithoutErrorCode: {
        id: 'ml.agent.endorsement.views.contact-us.CSC_NON_RETRYABLE_CONTACT_US_WITHOUT_ERROR_CODE',
        defaultMessage: 'We\'re sorry, we are experiencing technical difficulties with your policy change.'
    },
    CSCNonRetryableContactUs: {
        id: 'ml.agent.endorsement.views.contact-us.CSC_NON_RETRYABLE_CONTACT_US',
        defaultMessage: 'We\'re sorry, we are experiencing technical difficulties with your policy change {errorCode}'
    },
    mlContactUsChatPolicyNum: {
        id: 'ml.endorsement.views.contact-us.mlContactUsChatPolicyNum',
        defaultMessage: 'When contacting us via chat, please include your policy number <strong>{policyNumber}</strong>.'
    },
    mlUwIssueUnableToContinue: {
        id: 'ml.endorsement.views.contact-us.mlUwIssueUnableToContinue',
        defaultMessage: 'We\'re sorry, we are not able to continue your change online due to:'
    },
    mlDefaultContactUs: {
        id: 'ml.endorsement.views.contact-us.mlDefaultContactUs',
        defaultMessage: 'Please call <strong>1-800-422-4272</strong> to speak to one of our service representatives. They are available to assist you:<br></br>Monday - Friday from 8:00 am - 11:00 pm ET, Saturday from 9:00 am - 5:00 pm ET.'
    },
    mlDefaultErrorMsg: {
        id: 'ml.endorsement.views.contact-us.mlDefaultErrorMsg',
        defaultMessage: 'We\'re sorry, due to technical difficulties we are unable to process your change online at this time.<br></br>Please try again later.'
    }
});
